import { CalendarViewType } from '$features/calendar/enums/view-type'
import dayjs from 'dayjs'
import { useCalendar } from '$features/calendar/hooks/use-calendar'
import { Button, DatePicker } from '$components'
import { ChevronLeftIcon } from '$components'

export function CalendarNavigation() {
  const { setDate, viewType, date, getWeekRange } = useCalendar()

  const addDay = () => setDate(prev => prev.add(1, 'day'))
  const subtractDay = () => setDate(prev => prev.subtract(1, 'day'))
  const addWeek = () => setDate(prev => prev.add(1, 'week'))
  const subtractWeek = () => setDate(prev => prev.subtract(1, 'week'))

  const handleForwardClick = () => {
    switch (viewType) {
      case CalendarViewType.DAY:
        addDay()
        break
      case CalendarViewType.WEEK:
        addWeek()
        break
    }
  }

  const handleBackwardClick = () => {
    switch (viewType) {
      case CalendarViewType.DAY:
        subtractDay()
        break
      case CalendarViewType.WEEK:
        subtractWeek()
        break
    }
  }

  const handleTodayClick = () => setDate(dayjs.utc())

  return (
    <div className="flex gap-stack-tight items-center">
      <div className="flex gap-stack-dense items-center">
        <DatePicker
          trigger={() => (
            <DatePicker.Button className="py-stack-dense px-stack-tight">
              <h1 className="text-left text-heading-6 sm:text-heading-4 text-neutral-fg font-semibold">
                {viewType === CalendarViewType.DAY
                  ? dayjs(date).format('DD MMM YYYY')
                  : `${dayjs(getWeekRange().start).format('DD MMM YYYY')} — ${dayjs(getWeekRange().finish).subtract(1, 'day').format('DD MMM YYYY')}`}
              </h1>
            </DatePicker.Button>
          )}
          value={date}
          onChange={(date) => setDate(date!)}
        />

        <Button
          onClick={handleBackwardClick}
          variant="ghost"
          size="sm"
          className="!p-stack-tight"
        >
          <ChevronLeftIcon className="size-4" />
        </Button>

        <Button
          onClick={handleForwardClick}
          variant="ghost"
          size="sm"
          className="!p-stack-tight"
        >
          <ChevronLeftIcon className="size-4 rotate-180" />
        </Button>
      </div>

      <Button
        onClick={handleTodayClick}
        variant="secondary"
        size="sm"
      >
        Today
      </Button>
    </div>
  )
}
